import React from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css";

// Components
import ChatRoom from "./components/ChatRoom";
import CreateRoom from "./components/CreateRoom";

const App = () => {
  return (
    <div className="app-root">
      <Routes>
        <Route path="/" element={<CreateRoom />} />
        <Route exact path="/:room" element={<ChatRoom />} />
      </Routes>
    </div>
  );
};

export default App;
